import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const SmartphoneIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"smartphone"} ref={ref}/>
});

SmartphoneIcon.displayName = "SmartphoneIcon";
